import { call, put, takeLatest } from 'redux-saga/effects';

import { InsurerTeam } from '@models/InsurerTeam';
import { InsurerTeamApi } from '@apis/InsurerTeamApi';

import {
  insurerTeamsFetch,
  stateUpdate,
  StateUpdatePayload,
} from './action';

function* handleInsurerTeamsFetch() {
  const state: StateUpdatePayload = { teams: [] };
  try {
    state.teams = (yield call(InsurerTeamApi.getAll)) as InsurerTeam[];
    yield put(stateUpdate(state));
  } catch { }
}

export default function* () {
  yield takeLatest(insurerTeamsFetch, handleInsurerTeamsFetch);
}
